// extracted by mini-css-extract-plugin
export default {"shopPageWrapper":"style_shopPageWrapper__0C87U","switch":"style_switch__Vo4Pt","shopSwitch":"style_shopSwitch__Rj2QS","cartSwitch":"style_cartSwitch__W1FG6"};